// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1lvp4","sectionsWrapper":"style_sectionsWrapper__2FUR3"};